<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
                <el-form-item label="Category2" prop="category2CodesList">
                  <el-select v-model="queryCondition.category2CodesList" @change="changeCategory2" multiple clearable placeholder="请选择(支持多选)" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.code"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            <el-col :span="6">
              <el-form-item label="月" prop="monthList">
                <el-select v-model="queryCondition.monthList" clearable multiple placeholder="请选择(支持多选)" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in monthOptions" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Facility名称" prop="facilityName">
                <el-input v-model="queryCondition.facilityName" clearable placeholder="支持模糊查询" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onExport">导出</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" max-height="500" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" title="Category2" resizable min-width="100" field="category2Name"></ux-table-column>
        <ux-table-column align="center" title="月" field="month"></ux-table-column>
        <ux-table-column align="center" title="Facility编号" field="facilityCode"></ux-table-column>
        <ux-table-column align="center" title="Facility名称" field="facilityName"></ux-table-column>
        <ux-table-column align="center" title="DC发货量" field="outbound"></ux-table-column>
        <ux-table-column align="center" title="净重(KG)" field="netWeight"></ux-table-column>
        <ux-table-column align="center" title="更新时间" field="updateDate"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
import ReceiveValue from "@/api/ReceiveValue/index";
import QBRApi from "@/api/QBR/index";
import DQMPApi from "@/api/DQMP/index";
import commonFunction from "@/utils/dataTableUtils";

export default {
  name: '',
  components: {
    IcSelect,
  },
  data() {
    return {
      totalCount: 0,
      pages: 1,
      monthOptions: [],
      categoryList2: [],
      queryCondition: {
        facilityName: "",
        monthList: [],
        pageNum: 1,
        pageSize: 15,
      },
      category2List: [],
      category3List: [],
      tableData: [],
    }
  },
  created() {
    this.getCategory2Lists()
    this.getMonth()
    this.queryData();
  },
  methods: {
    queryData(val) {
      if(undefined != val){
        this.queryCondition.pageNum=1
      }
      ReceiveValue.findFacilityListPage(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
        this.pages = res.data.pages;
        this.$refs.plxTable.reloadData(res.data.records)
      });
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        facilityName: "",
        monthList: [],
        pageNum: 1,
        pageSize: 15,
      }
      this.queryData();
    },
    onExport() {
      DQMPApi.exportList(this.queryCondition);
    },
    getMonth() {
      DQMPApi.getMonth().then(res => {
        this.monthOptions = res
      })
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    getCategory2Lists() {
      var param = {
        categoryLevel: '2',
      }
      QBRApi.getCategoryLists(param).then(res => {
        console.log("🚀 ~ file: facilityDc.vue ~ line 128 ~ QBRApi.getCategoryLists ~ res", res)
        this.categoryList2 = res.data
      });
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
